import actionTypes from "../actionTypes";
import {IelTiempoData, IPointCoords, INotificacion, ISections} from "../../types";
import {LatLngTuple} from "leaflet";

const update = require('immutability-helper');


export const initialState = {
    notification: null as null | INotificacion,
    section: 'principal' as ISections,
    level: 0 as number,
    menu: false as boolean,
    elTiempoLatLon: {lat: 40.4167, lon: -3.74325} as IPointCoords,
    elTiempoData: {
        temperatura: 0,
        velocidadViento: 0,
        humedad: 0,
        icono: '',
        descripcion: '',
        fecha: ''
    } as IelTiempoData,
    dialogs: {
        opciones: '' as string,
        confirmacion_eliminar: '' as string,
        confirmacion_eliminar_usuario: '' as string,
        new_user: false as boolean,
        nota: '' as string,
        loading: false as boolean,
        activar_cuenta: false as boolean,
        crear_nota: {} as Record<string, any>,
        editar_nota: {} as Record<string, any>,
        estacion_sensores: {} as Record<string, any>,
        estaciones: false as boolean
    },
    parcela: '' as string,
    cargando: false as boolean,
    reload: false as boolean
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'notify':
            return update(state, {notification: {$set: action.notification}});

        case 'select-section':
            return update(state, {section: {$set: action.section}});

        case 'set-level':
            return update(state, {level: {$set: action.level}});

        case 'set-menu':
            return update(state, {menu: {$set: action.menu}});

        case 'set-eltiempo_latlon':
            return update(state, {elTiempoLatLon: {$set: action.elTiempoLatLon}});

        case 'set-eltiempo_data':
            return update(state, {elTiempoData: {$set: action.elTiempoData}});

        case 'set-parcela':
            return update(state, {parcela: {$set: action.parcela}});

        case 'open-opciones-dialog':
            return update(state, {dialogs: {opciones: {$set: action.callback}}});

        case 'open-confirmacion-eliminar-dialog':
            return update(state, {dialogs: {confirmacion_eliminar: {$set: action.callback}}});

        case 'open-confirmacion-eliminar-usuario-dialog':
            return update(state, {dialogs: {confirmacion_eliminar_usuario: {$set: action.callback}}});

        case 'open-new-user-dialog':
            return update(state, {dialogs: {new_user: {$set: action.callback}}});

        case 'open-nota-dialog':
            return update(state, {dialogs: {nota: {$set: action.callback}}});

        case 'open-loading-dialog':
            return update(state, {dialogs: {loading: {$set: action.callback}}});

        case 'open-activar-cuenta-dialog':
            return update(state, {dialogs: {activar_cuenta: {$set: action.callback}}});

        case 'open-crear-nota-dialog':
            return update(state, {dialogs: {crear_nota: {$set: action.callback}}});

        case 'open-editar-nota-dialog':
            return update(state, {dialogs: {editar_nota: {$set: action.callback}}});

        case 'open-estacion-sensores-dialog':
            return update(state, {dialogs: {estacion_sensores: {$set: action.callback}}});

        case 'cargando':
            return update(state, {cargando: {$set: action.cargando}});

        case 'reload':
            return update(state, {reload: {$set: action.reload}});

        case 'open-estaciones':
            return update(state, {dialogs: {estaciones: {$set: action.callback}}});

        default:
            return state
    }
}
